import React from 'react';
import './styles.css';

interface FormData {
  name: string;
  email: string;
  subject: string;
  message: string;
}

interface QueryFormComponentProps {
  formData: FormData;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

const QueryFormComponent: React.FC<QueryFormComponentProps> = ({
  formData,
  onChange,
  onSubmit
}) => {
  return (
    <form className="query-form" onSubmit={onSubmit}>
      <h2 className="form-heading">Contact Us</h2>

      {['name', 'email', 'subject'].map((field) => (
        <div className="form-group" key={field}>
          <label>{field.charAt(0).toUpperCase() + field.slice(1)}:</label>
          <input
            type={field === 'email' ? 'email' : 'text'}
            name={field}
            value={formData[field as keyof FormData]}
            onChange={onChange}
            required
          />
        </div>
      ))}

      <div className="form-group">
        <label>Message:</label>
        <textarea
          name="message"
          value={formData.message}
          onChange={onChange}
          required
          rows={4}
        />
      </div>

      <button type="submit" className="submit-btn">Submit</button>
    </form>
  );
};

export default QueryFormComponent;
